/**
 * JSON:API surface for antenatal (access-emr-core).
 *
 * GET/POST/PATCH  /pregnancy_episodes
 * POST            /pregnancy_episodes/:id/start_labour
 * POST            /pregnancy_episodes/:id/record_delivery
 * POST            /pregnancy_episodes/:id/complete
 * GET/PATCH       /anc_visits
 * POST            /anc_visits/:id/start  — creates intake + outpatient encounter
 * GET/PATCH       /postnatal_visits
 * GET/POST/PATCH  /anc_form_templates
 *
 * PN form schemas: frontend DEFAULT_PN_TEMPLATE today; API templates later.
 *
 * Orders & prescriptions reuse existing EMR endpoints on the visit encounter:
 *   lab_orders / imaging_orders / medications / invoice_items
 */
export const ANC_API_RESOURCES = {
  pregnancyEpisodes: '/pregnancy_episodes',
  ancVisits: '/anc_visits',
  postnatalVisits: '/postnatal_visits',
  ancFormTemplates: '/anc_form_templates',
  encounters: '/encounters'
} as const
